import { esquemaNovedad } from '../schemas/novedadSchema';
import { validarEsquemas } from './validarEsquemaHelper';
import {
  verificarEmpleadoExisteEnNovedad,
  verificarCoherenciaFechasNovedad,
} from './reglasNegocioHelper';
/**
 * Orquesta la validación completa de una novedad.
 * @param {Object} novedad - Datos de la novedad.
 * @param {number} lineaIndex - Índice de la fila en el archivo.
 * @param {Object} contexto - Datos externos (mapas para validar Enum).
 * @returns {Object} { errores: Array, novedad: Object }
 */
export const validarNovedadHelper = (novedad, lineaIndex, contexto) => {
  const erroresEsquema = validarEsquemas(
    novedad,
    lineaIndex,
    contexto,
    esquemaNovedad
  );

  if (erroresEsquema.length) {
    return {
      errores: erroresEsquema,
      novedad,
    };
  }

  const errores = [
    ...verificarEmpleadoExisteEnNovedad(
      novedad,
      contexto.empleadosSet,
      lineaIndex
    ),
    ...verificarCoherenciaFechasNovedad(novedad, lineaIndex),
  ];

  return {
    errores,
    novedad,
  };
};
